module.exports = __webpack_public_path__ + "img/from_toeic_fraction.0f0f18b8.svg";